import { render } from "./ProjectionList.vue?vue&type=template&id=4571583e&scoped=true"
import script from "./ProjectionList.vue?vue&type=script&lang=js"
export * from "./ProjectionList.vue?vue&type=script&lang=js"

import "./ProjectionList.vue?vue&type=style&index=0&id=4571583e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4571583e"]])

export default __exports__